import { IExtendedContext } from '../../../types/extendedContext';

import { selectServicePickerWidgetServicesResponse } from '../../../../shared/ServicePickerWidget';

export const getServicesHandler = (context: IExtendedContext) => () => {
  const state = context.store.getState();
  const terms = selectServicePickerWidgetServicesResponse(state);

  return terms;
};
